module.exports = __webpack_public_path__ + "img/banner-two-2.1f20fb73.png";